export default __webpack_public_path__ + "static/media/machined.62226bd1.svg";